<template>
  <div class="wrap" @click="clickNotice">

    <div class="scroll">
      <div class="article" @click.stop>
        <img src="../assets/logo_black.png" alt="">
        <div class="borderOutside">
          <div class="borderInside">
            <div v-html="noticeContent.content"></div>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
  export default {
    name: "Article",
    props: ['noticeContent'],
    methods: {
      clickNotice() {
        this.$emit('clickNotice', '')
      }
    },
    mounted() {
      console.log(this.noticeContent)

    }
  }
</script>

<style scoped lang="scss">
  .wrap {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.3);
    z-index: 9999;
    overflow-y: scroll;
    overflow-x: hidden;
    padding: 40px 0;
  }

  .scroll {
    height: auto;
    /*position: relative;*/
    margin-bottom: 40px;
  }

  .article {
    width: 50%;
    min-width: 600px;
    max-width: 800px;
    min-height: 90vh;
    background: #fff;
    padding: 60px 30px;
    box-sizing: border-box;
    position: relative;
    right: 0;
    left: 0;
    margin: 0 auto;

  }

  .article img {
    width: 60px;
    position: absolute;
    right: 30px;
    top: 10px;
  }

  ::-webkit-scrollbar {
    width: 0; /*滚动条宽度*/
    height: 0; /*滚动条高度*/
  }

  /*定义滚动条轨道 内阴影+圆角*/
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
    /*border-radius: 10px;  !*滚动条的背景区域的圆角*!*/
  }

  /*定义滑块 内阴影+圆角*/
  ::-webkit-scrollbar-thumb {
    /*border-radius: 10px;  !*滚动条的圆角*!*/
    /*-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);*/
    background-color: rgba(0, 0, 0, 0); /*滚动条的背景颜色*/
  }

  .borderOutside {
    padding: 2px 0;
    border-top: 4px solid $bg-color;
    border-bottom: 4px solid $bg-color;
    min-height: 70vh;
  }

  .borderInside {
    border-top: 2px solid $bg-color;
    border-bottom: 4px solid $bg-color;
    padding: 40px 0;
    min-height: 70vh;
  }

  /*.borderInside img{*/
  /*!*max-width: 60%;*!*/
  /*}*/

</style>



// WEBPACK FOOTER //
// src/components/Article.vue